import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Calculator as CalcIcon } from "lucide-react";
import Paywall from "../components/Paywall.jsx";
import { useIsPremium } from "../lib/premium";

export default function Calculators() {
  const premium = useIsPremium();
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (premium) api.get("/calculators").then((r) => setItems(r.data)).catch(() => {});
  }, [premium]);

  if (!premium) return <Paywall feature="Medical Calculators" />;

  const byCat = items.reduce((acc, c) => {
    (acc[c.category] ||= []).push(c);
    return acc;
  }, {});

  return (
    <div className="space-y-6" data-testid="calculators-page">
      <div>
        <div className="text-xs tracking-widest uppercase text-slate-500 font-semibold">Clinical Tools</div>
        <h1 className="font-heading text-3xl font-bold text-[#111827] mt-1">Medical Calculators</h1>
        <p className="text-slate-600 text-sm mt-1">Clinical scoring and dosing calculators.</p>
      </div>

      {Object.entries(byCat).map(([cat, group]) => (
        <div key={cat}>
          <h2 className="font-heading font-bold text-[#111827] mb-3">{cat}</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
            {group.map((c) => (
              <Link key={c.id} to={`/app/calculators/${c.id}`} data-testid={`calc-card-${c.id}`}>
                <Card className="border-slate-200 hover:border-[#0B5FFF]/40 hover:shadow-sm h-full transition-all">
                  <CardContent className="p-4">
                    <div className="flex items-start justify-between gap-2">
                      <div className="w-8 h-8 rounded-md bg-[#EFF4FF] text-[#111827] flex items-center justify-center flex-shrink-0">
                        <CalcIcon className="w-4 h-4" />
                      </div>
                      {c.ai_powered && (
                        <Badge className="bg-[#0B5FFF] text-white border-0 text-[9px] px-1.5">AI</Badge>
                      )}
                    </div>
                    <h3 className="font-heading font-semibold text-sm text-[#111827] mt-3 leading-snug line-clamp-2">{c.name}</h3>
                    <p className="text-xs text-slate-500 mt-1 line-clamp-2">{c.description}</p>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
